import {Types} from "../types";

type PathParam<T>                            = Types.Common.Utils.ArrPath.PathParam<T>;
type PathType<T, TPath extends PathParam<T>> = Types.Common.Utils.ArrPath.PathType<T, TPath>;

export function getNestedValue<T extends Record<any, any>>(obj:T, path?: []): T;
export function getNestedValue<T extends Record<any, any>, TPath extends PathParam<T>>(obj:T, path: TPath): PathType<T, TPath>;
export function getNestedValue(obj:any, path: any[]): any {
    if (path == null) {
        return obj;
    }
    for (const v of path) {
        if (obj == null) {
            return obj;
        }
        obj = obj[v];
    }
    return obj;
}
export const gnv = getNestedValue;

// export function setNestedValue<Value>(object: any, path: [], value: Value): Value;
// export function setNestedValue<T extends Record<any, any>, TPath extends PathParam<T>>(object:T, path: TPath, value: PathType<T, TPath>): T;
export function setNestedValue(object: any, path: any[], value: any) {
    if (path.length === 0) {
        return value;
    }

    let [attr1, ...lastAttrs] = path;

    const [attr, type] = typeof attr1 !== "string" ? [attr1, null] : attr1.indexOf("!") === -1 ? [attr1, null] : attr1.split("!");

    const createChild = () => type === "arr" ? [] : {};
    if (Array.isArray(object)) {
        let clone = object ? object.slice(0) : [];
        clone[attr] = setNestedValue(object && object[attr] || createChild(), lastAttrs as any, value);
        return clone;
    } else {
        return Object.assign({}, object, {[attr]: setNestedValue(object && object[attr] || createChild(), lastAttrs as any, value)});
    }
}
export const snv = setNestedValue;

export function changeNestedValue<T extends Record<any, any>, TPath extends PathParam<T>>(object:T, path: TPath, fn: (oldValue:PathType<T, TPath>) => PathType<T, TPath>): T {
    let oldValue = getNestedValue(object, path);
    let updatedValue = fn(oldValue);
    return updatedValue !== oldValue ? setNestedValue(object, path, updatedValue) : object;
}
export const cnv:any = changeNestedValue;

/**
 *
 * @deprecated use "gnv" instead
 */
export const getPath = getNestedValue;

/**
 * @deprecated use "snv" instead
 */
export const setPath = setNestedValue;

/**
 * @deprecated
 */
export const changePath = changeNestedValue;

export const locate = (obj:any, path: any[]) => {
    if (obj == null) {
        return null;
    }

    const [first, ...last] = path;

    const ret = ((cond) => {
        if (typeof cond === "object") {
            return obj.find((item:any) => !Object.keys(cond).find((k) => cond[k] !== item[k]));
        } else {
            return obj[cond];
        }
    })(first);

    if (last.length) {
        return locate(ret, last);
    } else {
        return ret;
    }
};

